import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["link", "style", "wide", "width", "height", "frameBorder", "allow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx as e } from "react/jsx-runtime.js";
export default (function (_ref) {
  var t = _ref.link,
      _ref$style = _ref.style,
      r = _ref$style === void 0 ? {} : _ref$style,
      _ref$wide = _ref.wide,
      i = _ref$wide === void 0 ? !1 : _ref$wide,
      _ref$width = _ref.width,
      o = _ref$width === void 0 ? i ? "100%" : 300 : _ref$width,
      _ref$height = _ref.height,
      a = _ref$height === void 0 ? i ? 80 : 380 : _ref$height,
      _ref$frameBorder = _ref.frameBorder,
      d = _ref$frameBorder === void 0 ? 0 : _ref$frameBorder,
      _ref$allow = _ref.allow,
      l = _ref$allow === void 0 ? "encrypted-media" : _ref$allow,
      m = _objectWithoutProperties(_ref, _excluded);

  var s = new URL(t);
  return e("iframe", Object.assign({
    title: "Spotify Web Player",
    src: "https://open.spotify.com/embed".concat(s.pathname),
    width: o,
    height: a,
    frameBorder: d,
    allow: l,
    style: _objectSpread({
      borderRadius: 8
    }, r)
  }, m), void 0);
});